import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import Products from 'merchandise-lib/constants/Product';
import { SmartCrmFaqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/SmartCrmFaqs';
import { SmartCrmProductIcon } from 'pricing-pages-ui-components/productIcon/SmartCrmProductIcons';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { NavMarker } from 'react-rhumb';
import { useEffect } from 'react';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
import PhoneSupportFooter from '../../components/phone-support/PhoneSupportFooter';
import { BannerSection } from '../../containers/BannerSection';
import { IntegrationsSection } from '../../containers/IntegrationsSection';
import { trackPageView } from '../../utils/tracking/trackingEventUtils';
import { SmartCrmFeatureTable } from './SmartCrmFeatureTable';
import { SmartCrmMerchCards } from './SmartCrmMerchCards';
import PhoneSupportMiddle from '../../components/phone-support/PhoneSupportMiddle';
import { SCREENS } from '../../constants/tracking/Screens';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SMART_CRM_API_NAMES = [Products.CORE_SEATS_PROFESSIONAL, Products.CORE_SEATS_ENTERPRISE];
export const SmartCrmPage = () => {
  const screen = SCREENS.SMART_CRM;
  useDocumentTitle(screen);
  useEffect(() => {
    trackPageView({
      screen
    });
  }, [screen]);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "SMART_CRM_PAGE_V2",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "SMART_CRM",
      apiNames: SMART_CRM_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsxs(PageTitle, {
        "aria-level": 1,
        children: [/*#__PURE__*/_jsx(SmartCrmProductIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.smart-crm.pageTitle"
        })]
      }), /*#__PURE__*/_jsx(PageSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.smart-crm.description"
        })
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(SmartCrmMerchCards, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(SmartCrmFeatureTable, {})
    }), /*#__PURE__*/_jsx(PhoneSupportMiddle, {
      phoneSourceId: "smart-crm-middle",
      screen: screen,
      apiName: Products.CORE_SEATS_PROFESSIONAL
    }), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "smart-crm"
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(SmartCrmFaqs, {})
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "smart-crm-footer",
      screen: screen,
      apiName: Products.CORE_SEATS_PROFESSIONAL
    })]
  });
};